import Transformer from '@/transformers/transformer'

export default class adjustmentTransformer extends Transformer {
  static fetch({}) {
    return {

    }
  }
  static sendInput({ comments, supply, movementDate, quantity, unitPrice }) {
    return {
      comment: comments,
      supply: supply.id,
      date_of_movement: movementDate,
      entry_quantity: quantity,
      unit_cost: unitPrice
    }
  }
  static sendOutput({ id, adjustmentOutput, comment }) {
    return {
      iwarehouse_supply: id,
      output_quantity: adjustmentOutput,
      comment
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/warehouse/adjustment.js